import { Grid } from '@material-ui/core'
import React from 'react'
type AppHeaderTemplateProps = {
  left?: React.ReactNode
  right?: React.ReactNode
  center?: React.ReactNode
  children?: React.ReactNode
  pl?: number
  pr?: number
  pt?: number
  pb?: number
}

function AppHeaderTemplate({
  pt = 0,
  pr = 0,
  pb = 0,
  pl = 0,
  ...props
}: AppHeaderTemplateProps): JSX.Element {
  return (
    <>
      <Grid
        container
        direction='row'
        justify='space-between'
        alignItems='flex-start'
        xs={12}
        item
        style={{
          padding: `${pt}px ${pr}px ${pb}px ${pl}px`
        }}
      >
        {props.left || props.right || props.center ? (
          <>
            <Grid>{props.left}</Grid>
            <Grid>{props.center}</Grid>
            <Grid>{props.right}</Grid>
          </>
        ) : undefined}
      </Grid>
      {props.children}
    </>
  )
}

export default AppHeaderTemplate
